var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"globalSettings"},[_c('div',{staticClass:"globalSettingsBox"},[_vm._m(0),_c('div',{staticClass:"globalSettingsContent"},[_c('router-view')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"globalSettingsNav"},[_c('li',{staticClass:"active"},[_c('i',{staticClass:"iconfont iconshijianxiao"}),_c('span',[_vm._v("时间设置")])])])
}]

export { render, staticRenderFns }